// Canal entre abas do MESMO navegador para sincronizar a EXIBIÇÃO dos pedidos em tempo
// real. Reusa o nome de canal já usado pelo stream SSE / silenciar-som / allday
// (useStreamPedidosCompartilhado e OperacaoTempoReal), onde trafegam mensagens
// { tipo: "evento" | "silenciar" | "allday" }. Aqui somamos { tipo: "pedido-atualizado" }.
//
// Motivação: quando UMA aba muda o status de um pedido (aceitar/preparar/despachar/
// finalizar/cancelar), as OUTRAS abas só descobriam pela rede de segurança (allday, até
// ~1 min) — e o ACEITE MANUAL nem emite evento SSE, então a aba do Recebedor seguia
// exibindo o pedido no estágio antigo até o allday. Este canal avisa as demais abas na
// hora, e cada uma reconcilia a exibição in-place (upsertPedidoNasListas), SEM recarregar
// a tela nem mexer na conexão SSE/QZ.
export const CANAL_PEDIDOS = "pedidos-sse"

// Id único desta ABA (não do navegador): o emissor marca a origem para as demais abas
// ignorarem o próprio eco — o BroadcastChannel entrega a mensagem a outras instâncias do
// canal na MESMA aba. Casa com o guard em OperacaoTempoReal.
export const ABA_ID =
    typeof crypto !== "undefined" && crypto.randomUUID
        ? crypto.randomUUID()
        : `${Date.now()}-${Math.random()}`

let canal: BroadcastChannel | null = null
function getCanal(): BroadcastChannel | null {
    if (typeof BroadcastChannel === "undefined") return null
    if (!canal) {
        try {
            canal = new BroadcastChannel(CANAL_PEDIDOS)
        } catch {
            canal = null
        }
    }
    return canal
}

// Anuncia às OUTRAS abas do navegador que este pedido mudou de status. Cada aba reconcilia
// a exibição na hora. Idempotente do outro lado (upsert por id, respeita status oculto).
// No-op se o pedido não tiver id ou o navegador não suportar BroadcastChannel.
export function anunciarPedidoAtualizado(pedido: any): void {
    if (!pedido?.id) return
    const bc = getCanal()
    if (!bc) return
    try {
        bc.postMessage({ tipo: "pedido-atualizado", pedido, origem: ABA_ID })
    } catch {
        /* ignore */
    }
}
